import React, { useState } from 'react';
import { Button, Navbar , Modal } from 'react-bootstrap';
import dashboard from '../../assets/dashboard.png';
import bitmap from '../../assets/create-bitmap.png';
import templateMsgCode from '../../assets/template-eye.png';
import templatePopup from '../../assets/template-popup.png';
import sendBulk from '../../assets/send-bulk.png';
import sendBulkDropdown from '../../assets/send-bulk-dropdown.png';
import notification from '../../assets/notification.png';
import { useNavigate } from 'react-router-dom';
function Help() {
  const navigate = useNavigate();
    const [showImageModal, setShowImageModal] = useState(false);
    const [selectedImg , setSelectedImg] = useState();
    const handleImageClick = (imgsrc) => {
        setSelectedImg(imgsrc);
        setShowImageModal(true);
      };
    
      const handleCloseImageModal = () => {
        setShowImageModal(false);
      };
      const data = [
  {
    imgSrc: dashboard,
    alt: "Dashboard",
    bullets: [
      "The menu options are located on the left side of the screen.",
      "Click on the Bitmap option to access the Bitmap section.",
      "This takes you to the Bitmap screen to create new bitmaps."
    ]
  },
  {
    imgSrc: bitmap,
    alt: "Bitmap Creation",
    bullets: [
      "You can select your preferred message channels from the available options.",
      "Assign dynamic priorities to each selected channel.",
      "If 'WhatsApp' is chosen, message code will be automatically enabled."
    ]
  },
  {
    imgSrc: templateMsgCode,
    alt: "TemplateMsgCode",
    bullets: [
      "If you have previously created any templates, they will be displayed in the message code section.",
      "Selecting an option in the 'Message Code' field will display an eye icon next to it.",
      "Clicking the eye icon opens a template preview in a popup.",
      "Then click on Create Bitmap."
    ]
  },
  {
    imgSrc: templatePopup,
    alt: "TemplatePopup",
    bullets: [
      "Bitmap usage in mGate requires Super Admin approval.",
      "Click on SendBulk option."
    ]
  },
  {
    imgSrc: sendBulk,
    alt: "SendBulk",
    bullets: [
      "Clicking on 'Select a Bitmap' will reveal a dropdown, allowing you to view and select your created bitmap."
    ]
  },
  {
    imgSrc: sendBulkDropdown,
    alt: "SendBulkDropdown",
    bullets: [
      "In the message content section, enter your message, and a live preview will be displayed in the message preview section.",
      "Provide mobile numbers separated by commas, and the system will automatically display the count of valid and invalid numbers below and then click on send.",
      "You can access your data in the notification table and search efficiently by mobile numbers or GUIDs.",
      "The status of the mobile numbers can be viewed in the Status column."
    ]
  },
  {
    imgSrc: notification,
    alt: "Notification",
    bullets: []
  }
];
  return (
    <div>
        {showImageModal && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999
          }}>
            <div
              onClick={handleCloseImageModal}
              style={{
                position: 'absolute',
                top: '10px',
                right: '20px',
                fontSize: '30px',
                color: 'white',
                cursor: 'pointer',
                zIndex: 1000
              }}
            >
              &times;
            </div>
            <img 
              src={selectedImg} 
              alt="Bitmap Creation" 
              className="img-fluid" 
              style={{
                width: '80%',
                height: '90vh',
                objectFit: 'contain',
                zIndex: 9999,
              }} 
            />
          </div>
        )}
       
              <div>
                <h4>How to create Bitmaps</h4>
                {data.map((item, index) => (
                  <div key={index}>
                    <img 
                      src={item.imgSrc} 
                      alt={item.alt} 
                      className="img-fluid w-75 mx-auto d-block my-3" 
                      onClick={() => handleImageClick(item.imgSrc)} 
                      style={{ cursor: 'pointer', border: '1px solid #333', borderRadius: '10px', boxShadow: '0 8px 10px 0 rgba(0, 0, 0, 0.7)' }} 
                    />
                    {item.bullets.length > 0 && (
                    <ul className="img-fluid w-75 mx-auto d-block my-3" style={{ fontSize: "16px", lineHeight: "1.8", color: "#333" }}>
                      {item.bullets.map((bullet, i) => (
                        <li key={i}>{bullet}</li>
                      ))}
                    </ul>
                    )}
                  </div>
                ))}
              </div>
            
    </div>
  );
}

export default Help;